/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.UserDefinedControls {
    angular.module("meevo.plugins.userDefinedControls", []);
}
